import React, {useState, useEffect, useRef} from 'react'
import styled from 'styled-components'
import moment from 'moment'
import {itemAPI2} from '../../libs/api2'
import {numberFormat} from "../../libs/util"
import {useReactToPrint} from 'react-to-print'

const EstimateCapture = (props) => {
    const [estimateInfo, setEstimateInfo] = useState(null)
    const [mallInfo, setMallInfo] = useState(null)
    const [estimateItem, setEstimateItem] = useState(null)
    const [TotalPrice, setTotalPrice] = useState(null)
    const [itemLoading, setItemLoading] = useState(false)
    const date = new Date()
    const printRef = useRef(null)
    const handlePrint = useReactToPrint({
        content: () => printRef.current,    // 인쇄할 컴포넌트의 ref를 전달합니다.
        // documentTitle: document.title?document.title:'행복쇼핑' + '온라인 견적서',
    });

    useEffect(() => {
        setEstimateItems()
    }, [])

    const setEstimateItems = () => {
        setItemLoading(true)
        const type = props.priceType || 'cash'
        itemAPI2.getItemEstimatePrint(type,props.estimateIdx,props.minishopIdx).then((response) => {
            if (response.status === 200) {
                setItemLoading(false)
                const {items, itemsPrice} = response.data
                if (items) {
                    setEstimateItem(items)
                    setTotalPrice(itemsPrice)
                    document.title='행복쇼핑 온라인 견적서'
                }
                /*미니샵 몰 정보 추가*/
                if(props.minishopIdx){
                    const {estimate,mall} = response.data
                    if (items) {
                        setEstimateInfo(estimate)
                        setMallInfo(mall)
                        document.title=mall?.mallName + ' 온라인 견적서'
                    }
                }
            }
        }).then(() => {
            handlePrint()
            props.onClickPrintHandler()
        })
    }

    return (
        <>
            <EstimatePrintContainer>
                <Style className="estimate-save-wrapper" ref={printRef}>
                    {!itemLoading ? (
                        estimateItem ? (
                            <>
                                {props.minishopIdx?
                                    <MinishopTop>
                                        <div className='top-box'>
                                            <div className='top-logo'><img src={mallInfo?.mallImage} alt={mallInfo?.mallWebUser}/></div>
                                            <div className='top-title'>온라인 견적서</div>
                                            <div></div>
                                        </div>
                                        <div className='middle-box'>
                                            <div>
                                                <div className='mall-tr'>
                                                    <span className='td-1-title'>견적번호</span>
                                                    <span className='td-1-content'>{props.estimateIdx}</span>
                                                </div>
                                                <div className='mall-tr'>
                                                    <span className='td-1-title'>주문자</span>
                                                    <span className='td-1-content'>{estimateInfo?.nameEstimate} 고객님</span>
                                                </div>
                                                <div className='mall-tr'>
                                                    <span className='td-1-title'>견적일자</span>
                                                    <span className='td-1-content'>{moment(estimateInfo?.dateEstimate).format("YYYY.MM.DD.HH:mm")}</span>
                                                </div>
                                                <div className='mall-tr mall-tr-price' >
                                                    <span className='td-1-title'>견적금액</span>
                                                    <span className='td-1-content td-1-price'><span className='total-price'>{numberFormat(TotalPrice)}</span><span>원</span>{mallInfo?.isCashAuto===1?<span className='tax-price'>&nbsp;(부가세포함)</span>:<span></span>}</span>
                                                </div>
                                                <div>
                                                    <span className='td-1-condition'>
                                                        - 견적유효 : 발행일로부터 1일간<br/>
                                                        - 납기조건 : 결제 후 48시간 이내 (토/일요일, 공휴일 제외)<br/>
                                                        - 품질보증 : 제품 납기 후 1년간 무상보증 (일부품목 제외)
                                                    </span>
                                                </div>
                                            </div>
                                            <div>
                                                <div className='seal'>
                                                    <span><img src={mallInfo?.sealImage} alt={mallInfo?.mallWebUser}/></span>
                                                </div>
                                                <div className='mall-tr'>
                                                    <span className='td-2-title td-2-owner'>공급자</span>
                                                </div>
                                                <div className='mall-tr'>
                                                    <span className='td-2-title'>사업자번호</span>
                                                    <span className='td-2-content'>{mallInfo?.bNumberFirm}</span>
                                                </div>
                                                <div className='mall-tr'>
                                                    <span className='td-2-title'>상호명</span>
                                                    <span className='td-2-content'>{mallInfo?.mallName}</span>
                                                    <span className='td-3-title'>대표</span>
                                                    <span className='td-3-content'>{mallInfo?.bNameHead}</span>
                                                </div>
                                                <div className='mall-tr'>
                                                    <span className='td-2-title'>주소</span>
                                                    <span className='td-2-content td-2-addr'>{mallInfo?.address}</span>
                                                </div>
                                                <div className='mall-tr'>
                                                    <span className='td-2-title'>업태</span>
                                                    <span className='td-2-content'>{mallInfo?.bCondit}</span>
                                                    <span className='td-3-title'>종목</span>
                                                    <span className='td-3-content'>{mallInfo?.bType}</span>
                                                </div>
                                                <div className='mall-tr'>
                                                    <span className='td-2-title'>대표전화</span>
                                                    <span className='td-2-content'>{mallInfo?.hp}</span>
                                                    <span className='td-3-title'>FAX</span>
                                                    <span className='td-3-content'>{mallInfo?.fax}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </MinishopTop>
                                    :
                                    <div className="top">
                                        <div className='leftField'>
                                            <div className="logo-field">
                                                <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_logo/1/1_180_72.png`} alt="행복쇼핑" />
                                            </div>
                                            <div className="top-content-field">
                                                국내 최저가 PC견적 서비스 <span><a href='https://www.pping.kr'>PC.PPING.KR</a></span>
                                            </div>
                                        </div>
                                        <div className="title-field">
                                            <h2>온라인 견적서</h2>
                                        </div>
                                        <div className="date-field">
                                            {moment(date).format("YYYY.  MM.  DD")}
                                        </div>
                                    </div>
                                }

                                <table className='table'>
                                    <thead className='thead'>
                                        <tr className='column'>
                                            <td className='num'>번호</td>
                                            <td className='cate'>분류</td>
                                            <td className='name'>상품명</td>
                                            <td className='min-money'>{props.minishopIdx?'판매가':'최저가'}</td>
                                            <td className='quantity'>수량</td>
                                            <td className='amount'>합계</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {estimateItem.map((el, index) => {
                                            return(
                                                <tr className='row' key={`${el.itemId}_${index}`}>
                                                    <td className="column num">{index+1}</td>
                                                    <td className="column cate">{el.categoryName}</td>
                                                    <td className="column name">{el.itemId===0||el.itemId===''||el.itemId===null||el.itemId===undefined?<span>{props.minishopIdx?mallInfo?.mallName:''} 배송비</span>:<span>{el.itemFullName}<span className="item-id"><span>&nbsp;-&nbsp;</span>{el.itemId}</span></span>}</td>
                                                    <td className="column min-money" style={{color:typeof el.price==='number'?'#333333':'#999999'}}>{typeof el.price==='number'?props.minishopIdx?el.price===0?'무료':numberFormat(el.price):numberFormat(el.price):props.minishopIdx?'일시품절':el.price}</td>
                                                    <td className="column quantity">{el.count}</td>
                                                    <td className="column amount">
                                                        {typeof el.price==='number'?props.minishopIdx?el.price===0?'무료':<span style={{color:'#333333'}}>{numberFormat(el.price * el.count)}</span>:<span style={{color:'#333333'}}>{numberFormat(el.price * el.count)}</span>:props.minishopIdx?'일시품절':el.price}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                    <tfoot className="tfoot">
                                        <tr>
                                            <td><span>ㆍ</span><span>행복쇼핑이 100% 안전 거래를 보장합니다.</span></td>
                                            <td><span>ㆍ</span><span>{props.minishopIdx?'납기 후 1년간 무상보증 (일부품목 제외)':'판매가격의 변동에 따라 최저가격과 실제 구매가격이 상이할 수 있습니다.'}</span></td>
                                        </tr>
                                        <tr className="total-price">
                                            <td className="txt">견적 합계</td>
                                            <td className="price">
                                                <strong className="amount">{numberFormat(TotalPrice)}</strong>
                                                <span className="wons">&nbsp;원</span>
                                                {props.minishopIdx?mallInfo?.isCashAuto===1?<span className="tax">&nbsp;(부가세포함)</span>:'':''}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                                {props.minishopIdx?
                                    <div className='delivery-info'>
                                        <div><span>ㆍ배송비 참고사항</span>&nbsp;&nbsp;제주, 도서/산간지역은 추가비용이 발생할 수 있으며, 최종 금액은 주문/결제 화면에서 확인 가능합니다.</div>
                                    </div>
                                    :
                                    ''
                                }
                            </>
                        ) : (
                            <div className="no-item">상품견적에 담긴 상품이 없습니다.</div>
                        )
                    ) : (
                        <div className="loading">
                            <img
                                src="//cdnimg.happyshopping.kr/img_static/img_pres/_v5/happy_loading_5.gif"
                                alt="loading"
                            />
                        </div>
                    )}
                </Style>
            </EstimatePrintContainer>
        </>
    )
}

const EstimatePrintContainer = styled.div`
    @media print {
        @page {
            margin-top:50px;
            margin-bottom:50px;
        }
        .row {
            page-break-inside: avoid; /* 페이지 내에서 잘림을 방지하기 위한 속성 추가 */
        }
    }
    //display:none; // 레이어 띄우지 않고 바로 인쇄
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    overflow-y: auto;
    padding:56px 0 0 0;

    font-size:12px;
    font-family:'Noto Sans KR', sans-serif;
    color:#333;
    font-weight:400;
`

const Style = styled.div`
    width: 690px;
    margin: 0 auto;
    div {
        box-sizing: border-box;
    }
    .top {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin:0 0 20px 0;
        text-align: center;
        align-content: flex-end;

        position: relative;
        .leftField{
            display:flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            .logo-field {
                img {
                    width: 90px;
                }
            }
            .top-content-field{
                letter-spacing:-0.9px;
                line-height:17px;
                &>span{color:#418DED;}
            }
        }
        .title-field {
            //position: fixed;
            position: absolute;
            left:50%;
            transform: translateX(-50%);
            letter-spacing:-0.85px;
            font-weight:900;
            line-height:49px;
            h2 { font-size: 34px; }
        }
        .date-field {
            margin-top: auto;
            color: #AAAAAA;
            letter-spacing: -0.66px;
            line-height:17px;
        }
    }

    .table{
        width:100%;
        .thead{
            border-top: 2px solid #AAAAAA;
            border-bottom: 1px solid #DCDCDC;
            .column {
                box-sizing: border-box;
                display: flex;
                align-items: center;
                text-align: center;
                flex-wrap: wrap;
                padding:11px 0;
            }
            .num { width: 32px; }
            .cate { width: 72px; }
            .name { width: 385px; }
            .min-money { width: 80px; }
            .quantity { width: 32px; }
            .amount { width: 89px; }
        }
        .row {
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom:1px solid #DCDCDC;
            align-content: center;
            padding:11px 0;
            .column {
                justify-content: center;
                box-sizing: border-box;
            }
            .num {
                width:32px;
                font-size:11px;
                line-height:16px;
                text-align: center;
            }
            .cate {
                width:72px;
                font-weight:bold;
                line-height:17px;
                justify-content:center;
                text-align: center;
            }
            .name {
                padding:0 16px;
                width:385px;
                line-height: 17px;
                display: flex;
                justify-content: flex-start;
                align-items:center;
                &>span:nth-of-type(1){font-weight:bold;}
                .item-id {color: #418DED;font-weight:400;}
                .item-id>span{color:#333;font-weight:400;}
            }
            .min-money{
                width:80px;
                justify-content: flex-end;
                padding: 0 8px 0 0;
                letter-spacing: -0.3px;
                line-height: 18px;
                text-align: right;
            }
            .quantity {
                width:32px;
                justify-content: center;
                letter-spacing: -0.3px;
                line-height: 18px;
                text-align: center;
            }
            .amount {
                width:89px;
                justify-content: flex-end;
                padding: 0 8px 0 0;
                line-height: 18px;
                letter-spacing:-0.3px;
                text-align: right;
                color:#999999;
            }
        }

        .tfoot {
            border-bottom: 2px solid #AAAAAA;
            padding: 19px 8px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color:#666666;
            tr {
                font-size: 12px;
                letter-spacing: -0.6px;
                line-height: 18px;
                td {
                    display: flex;
                    &:nth-of-type(n+2) {
                        margin-top: 4px;
                    }
                }
            }
            .total-price {
                display: flex;
                align-items: flex-end;
                font-weight: bold;
                .txt {
                    font-size: 16px;
                    margin-right: 8px;
                    letter-spacing: -0.4px;
                }
                .price {
                    display: flex;
                    align-items: flex-end;
                    .amount {
                        font-size: 19px;
                        letter-spacing: -0.47px;
                        color:#333333;
                    }
                    .wons {
                        font-size: 13px;
                        letter-spacing: -0.33px;
                    }
                    .tax{
                        font-size: 13px;
                        letter-spacing: -0.97px;
                        line-height: 19px;
                        color:#F34522;
                        align-content:baseline;
                    }
                }
            }
        }
    }
    .delivery-info{
        margin-top:25px;
        width:100%;
        border:1px solid #AAAAAA;
        color:#666666;
        padding:16px 0 16px 8px;
        span{
            font-weight: bold;
            letter-spacing: -0.66px;
            line-height: 18px;
            font-size:12px;
            color:#333333;
        }

    }

    .no-item {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        height: 160px;
    }
    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 160px;
        &>img {
            width: 60px;
            height: auto;
        }
    }
`

const MinishopTop = styled.div`
    font-size:14px;
    .top-box{
        position: relative;
        .top-title{
            display:flex;
            justify-content:space-between;
            align-items:center;
        }
        .top-logo{
            width:90px;
            height:51px;
            display:flex;
            align-items:center;
            img{ width:100%; }
        }
        .top-title{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size:34px;font-weight:900;line-height:49px;letter-spacing: -0.85px;
        }
    }

    .middle-box{
        margin-top:20px;
        margin-bottom:34px;
        border-top:2px solid #E5E5E5;
        border-bottom:2px solid #E5E5E5;
        padding:16px 0;
        display:flex;

        &>div{flex:1;box-sizing:border-box;}
        &>div:nth-of-type(1){order:1;}
        &>div:nth-of-type(2){order:2;border-left:1px solid #C8C8C8;}

        &>div{
            display:flex;
            flex-direction:column;
            justify-content:space-between;
        }
        &>div:nth-of-type(2){padding-left:16px;position:relative;}
        .seal{position:absolute;top:0;right:0;width:64px;height:64px;}
        .seal img{width:100%;}

        .mall-tr{display:flex;align-items:center;}
        span{display:inline-block;line-height:1.5;word-break:break-all;}

        .td-1-title{width:52px;font-weight:bold;}
        .td-2-title{width:65px;font-weight:bold;}
        .td-3-title{width:26px;font-weight:bold;}
        .td-2-owner{font-size:18px;;margin-bottom:12px;}

        .td-1-content{padding-left:16px;}
        .mall-tr-price{display:flex;align-items:center;margin-bottom:10px;}
        .total-price{font-size:19px;font-weight:900;}
        .tax-price{color:#F34522;}
        .td-1-condition{font-size:13px;color:#AAAAAA;}

        .td-2-content{padding-left:8px;width:125px;letter-spacing:-0.77px;}
        .td-2-addr{width:280px;}
        .td-3-content{padding-left:8px;width:125px;}
    }
`

export default EstimateCapture



// WEBPACK FOOTER //
// ./src/estimate_list/components/layer/EstimatePrint.js